import { API_ENDPOINTS } from "@/configs";
import apiRequest from "@/lib/axios";

export interface PushStatus {
  enabled: boolean;
  publicKey: string | null;
  subscribed: boolean;
}

export const getPushStatus = async (endpoint?: string): Promise<PushStatus> =>
  apiRequest({
    method: "GET",
    url: API_ENDPOINTS.PUSH.STATUS,
    params: endpoint ? { endpoint } : undefined,
    errorMessage: "Failed to load push settings",
  });

export const savePushSubscription = async (
  subscription: PushSubscriptionJSON,
): Promise<PushStatus> =>
  apiRequest({
    method: "POST",
    url: API_ENDPOINTS.PUSH.SUBSCRIBE,
    data: { endpoint: subscription.endpoint, keys: subscription.keys },
    errorMessage: "Failed to turn on push notifications",
  });

export const removePushSubscription = async (endpoint: string): Promise<void> => {
  await apiRequest({
    method: "POST",
    url: API_ENDPOINTS.PUSH.UNSUBSCRIBE,
    data: { endpoint },
    timeout: 5000,
    errorMessage: "Failed to turn off push notifications",
  });
};

export const sendTestPush = async (): Promise<{ sent: number }> =>
  apiRequest({
    method: "POST",
    url: API_ENDPOINTS.PUSH.TEST,
    errorMessage: "Failed to send a test notification",
  });
